<template>
  <div class="line"></div>
  <!-- 聯繫我們 -->
  <div class="lxwm">
    <div class="ppjs-title">聯繫我們</div>
    <div class="cpzs-dz"></div>
    <el-form label-width="120px">
      <el-form-item
        class="c093"
        label="電話（香港）："
        @click="callPhone('00852-24271159')"
      >
        （852）24271159</el-form-item
      >
      <el-form-item label="傳真（香港）："> (852) 2480-4601</el-form-item>
      <el-form-item label="地址（香港）：">
        香港葵涌和宜合167-171號金威工業大廈5字樓A座</el-form-item
      >
    </el-form>
    <div class="xline"></div>
    <el-form label-width="120px">
      <el-form-item
        class="c093"
        label="電話（東莞）："
        @click="callPhone('0769-83362372')"
      >
        0769-83362372</el-form-item
      >
      <el-form-item label="傳真（東莞）："> 0769-83362222</el-form-item>
      <el-form-item label="地址（東莞）：">
        廣東省東莞市黃江鎮黃江擁軍一路2號101室</el-form-item
      >
    </el-form>
    <el-image :src="addrm"></el-image>
    <!-- 地图接入 -->
    <!-- <div>
      <div id="map" style="width:500px;height:400px;"></div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Footer_m",
  data() {
    return {
      addrm: "http://139.159.153.112:8200/gw_lmm/lmmaddr.png",
    };
  },
  methods: {
    callPhone(phoneNumber) {
      window.location.href = "tel://" + phoneNumber;
    },
    // 初始化地图
        initMap () {
        console.log(window)
    // 定义地图中心点坐标  114.040057,22.91513
      var center = new window.qq.maps.LatLng(22.91513, 114.040057)
      // 定义map变量，调用 qq.maps.Map() 构造函数创建地图
      var map = new window.qq.maps.Map(document.getElementById('map'), {
        center: center, // 设置地图中心点坐标
        zoom: 15, // 设置地图缩放级别
        //pitch: 43.5, // 设置俯仰角
        //rotation: 45 // 设置地图旋转角度
      })
      console.log(map)
      console.log(window)
    }
  },
  mounted() {
    console.log(122)
    // this.initMap();
  },
};
</script>

<style scoped>
.line {
  width: 100%;
  height: 5px;
  background: rgb(244, 244, 244);
}
.cpzs-dz {
  width: 30px;
  height: 3px;
  margin: 10px auto;
  background-color: rgb(87, 190, 173);
}
/* 聯繫我們 */
.lxtb {
  text-align: left;
  margin-left: 25px;
}
.lxwm-wz {
  color: rgb(179, 141, 84);
}
.el-form-item {
  margin-bottom: 0px !important;
  text-align: left;
}
.xline {
  width: 100%;
  height: 1px;
  background: rgb(244, 244, 244);
}
.ppjs-title {
  padding-top: 30px;
  font-size: 22px;
  color: #2b2b2b;
}
</style>